module.exports = __webpack_public_path__ + "img/heart.ef5cd799.svg";